import React,{useContext} from 'react';
import "../styles/App.scss";
import {SoundContext} from "./SoundContext";
import Settings from './Settings';
import SoundButtonPlayer from './SoundButtonPlayer';

const SOUND_ON = "/images/icons/toggle-soundon.png";
const SOUND_OFF = "/images/icons/toggle-soundoff.png";

const SON_NAME = "Sound On";
const SOFF_NAME = "Sound Off";

function SoundToggle(){
    const {isSoundOn,toggleSound} = useContext(SoundContext);

    const imgToUse = isSoundOn ? SOUND_ON : SOUND_OFF
    const btnName = isSoundOn ? SON_NAME : SOFF_NAME

    const handleToggleClick =()=>{
        toggleSound();//togglesound passed in
    }

    return(
        <div>
            <SoundButtonPlayer onClick={handleToggleClick}>
                {/* <img src={imgToUse} alt={btnName} className="settingIcon"/> */}
                <Settings
                    settingImg={imgToUse}
                    settingName={btnName}
                />
            </SoundButtonPlayer>
             
        </div>
    );
}
export default SoundToggle;